var $09game = function (token, a_id, test) {
	var _this = this;
	_this.a_id = a_id;
	_this.token = token;
	var now;
	var url = !test ? 'https://shop.09game.com/shop?' : 'http://192.168.1.79:1288/shop?';
	try {
		now = new Date($.ajax({ async: false }).getResponseHeader("Date")).setHours(0, 0, 1, 0);
	} catch (error) {
		now = new Date().setHours(0, 0, 1, 0);
	}
	_this.q_d = function (t, j, cb) {
		var p_j = JSON.stringify({ type: t, json: JSON.stringify(j) });
		$.ajax({
			url: url + p_j,
			async:false,
			success: function (r) {
				if (typeof r == "string") {
					r = JSON.parse(r);
				}
				cb(r);
			},
			error: function (e) {
				console.warn('type类型:' + t + '，JSON内容' + JSON.stringify(j) + '，接口错误！');
			}
		})
	}
	_this.q_a = function (cb) {
		_this.q_d('q_cfg_app', { query_id: 0, days: 100, count: 10000 }, cb);
	}
	_this.q_m_p = function (cb) { 
		_this.q_d('q_my_packet', { token: _this.token }, cb);
	}
	_this.q_t = function (cb) {
		var tl = [];
		_this.q_d('q_cfg_task', { app_id: _this.a_id }, function (r) {
			if (r.code == 0) {
				for (var i in r.records) {
					r.records[i].p = null;//q_my_packet
					r.records[i].c = [];//q_my_task
					r.records[i].s = [];//q_cfg_packet
					r.records[i].cn = '';//按钮状态
					r.records[i].over_step = 0;
				}
				tl = r.records;
			} else {
				console.warn(r.info);
			}
			_this.q_m_t(cb, tl);
		});
	}
	_this.q_m_t = function (cb, tl) {
		_this.q_d('q_my_task', { app_id: _this.a_id, token: _this.token }, function (r) {
			if (r.code == 0) {
				for (var j in tl) {
					for (var i in r.records) {
						r.records[i].e_t = Date.parse(new Date(r.records[i].end_time.replace(/-/g, "/")));
						r.records[i].c_t = Date.parse(new Date(r.records[i].create_time.replace(/-/g, "/")));
						if (r.records[i].task_id == tl[j].task_id ) {
							tl[j].c.push(r.records[i]);
							tl[j].over_step = r.records[i].over_step;
						}
					}
					tl[j].c.sort(function(a,b){
						return b.e_t - a.e_t;
					})
					
					tl[j].c = tl[j].c[0];
				}
			} else {
				console.warn(r.info);
			}
			_this.q_t_p(cb, tl);
		})
	}
	_this.q_t_p = function (cb, tl) {
		_this.q_d('q_cfg_packet', { app_id: _this.a_id }, function (r) {
			if (r.code == 0) {
				for (var i in r.records) {
					r.records[i].s = [];
					for (var k = 1; k <= 6; k++) {
						var str = 'gift' + k + '_setting';
						if (r.records[i][str]) {
							r.records[i].s.push(JSON.parse(r.records[i][str]));
						}
					}
					for (var j in tl) {
						if (r.records[i].packet_id == tl[j].packet_id) {
							tl[j].s = r.records[i].s;
							tl[j].use_flag = r.records[i].use_flag;
						}
					}
				}
			} else {
				console.warn(r.info);
			}
			if (tl) {
				_this.q_m_t_p(cb, tl);
			} else {
				cb(r);
			}
		})
	}
	_this.q_m_t_p = function (cb, tl) {
		var id = typeof tl == 'number' ? tl : _this.a_id;
		var f = typeof tl == 'number';
		_this.q_d('q_my_packet', { app_id: id, token: _this.token }, function (r) {
			if (r.code == 0) {
				for (var i in r.records) {
					if (f) {
						cb(r);
					} else {
						for (var j in tl) {
							if (tl[j].packet_id == r.records[i].packet_id) {
								tl[j].p = r.records[i];
							}
						}
					}
				}
				if (!f) {
					_this.o_t(tl, cb);
				}
			} else {
				console.warn(r.info);
				if (f) { 
					cb(r)
				} else { 
					cb(tl)
				}
			}
		})
	}
	_this.o_t = function (tl, cb) {
		for (var i in tl) {
			var item = tl[i];
			if (item.c && item.c.e_t >= now) { 
				if (item.p && item.p.balance > 0 && item.p.expire_days > 0) { 
					item.cn='get';
				}else{
					if (item.c.over_step >= item.c.total_step) { 
						item.cn='over'
					}
				}
			}
		}
		if(cb){
			cb(tl);
		} else { 
			return tl;
		}
	}
	_this.g_t = function (id, cb) {
		_this.q_d('use_packet', { token: _this.token, packet_id: id }, function (r) {
			if (r.code == 0) {
				cb(r);
			} else {
				console.warn(r.info);
			}
		})
	}
}

export default $09game


// WEBPACK FOOTER //
// ./src/assets/js/s27/taskplugin.js